export default {
  share: {
    fullUrl: 'Celé',
    shortUrl: 'Krátké',
    urlCopied: 'URL zkopírovaná do schránky.',
    clickToCopy: 'Kliknutím zkopírovat URL adresu',
    share: 'Sdílet (kliknutím zkopírovat)',
    shareLink: 'Sdílet odkaz',
    short: 'Krátké URL',
    copyUrlInfo: 'Odkaz můžete také zkopírovat z adresního řádku prohlížeče.',
    urlShortened: 'Zkrácené URL',
    shorteningNotPossible: 'Nebylo možné vygenerovat krátkou adresu URL. Použijte prosím úplnou adresu URL',
    embedCodeCopied: 'Kód pro vložení zkopírován',
    embed: 'Vkládání (kliknutím zkopírujete)',
    embedInstructions: 'Tento kód použijte k vložení mapy ORS na svůj web'
  }
}
